<template>
  <div class="config-creation">
    <v-card class="mt-6 mb-6">
      <v-card-title>Configuration d'une nouvelle ligne </v-card-title>
      <v-row class="mr-6 ml-6">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="config.name"
            label="Nom du groupe"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="config.site.id"
            :items="sites"
            item-text="name"
            item-value="id"
            label="Sites"
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="mr-6 ml-6">
        <v-col cols="12" md="4">
          <v-select
            v-model="config.acqui_platform.id"
            :items="platforms"
            item-text="name"
            item-value="id"
            label="Plateformes"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="config.acqui_metric.id"
            :items="filteredMetrics"
            item-text="name"
            item-value="id"
            label="Métriques"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="config.acqui_utm.id"
            :items="filteredUtms"
            :item-text="utmText"
            item-value="id"
            label="Utms"
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-12 pb-6">
        <v-btn class="ml-6 mr-6 secondary" @click="saveConfig"
          >Enregistrer</v-btn
        >
        <v-btn class="ml-6 mr-6 primary" @click="cancelConfig">Annuler</v-btn>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
export default {
  name: "ConfigCreation",
  components: {},
  data() {
    return {
      config: {
        id: "",
        name: "",
        acqui_platform: { id: "" },
        acqui_metric: { id: "" },
        acqui_utm: { id: "" },
        site: { id: "" },
      },
      filteredMetrics: [],
      filteredUtms: [],
    };
  },
  setup() {
    const { axiosGet, axiosPost, isLoading } = useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
    };
  },
  async created() {},
  methods: {
    utmText(item) {
      const truncate = (str) =>
        str.length > 10 ? str.slice(0, 10) + "..." : str;
      const source = item.source;
      const campaign = truncate(item.campaign || "");
      return `${source} / ${campaign}`;
    },
    cancelConfig() {
      (this.config = {
        id: "",
        name: "",
        acqui_platform: { id: "" },
        acqui_metric: { id: "" },
        acqui_utm: { id: "" },
        site: { id: "" },
      }),
        this.$emit("close-dialog");
    },
    async saveConfig() {
      const params = {
        name: this.config.name,
        acqui_platform_id: this.config.acqui_platform.id,
        acqui_metric_id: this.config.acqui_metric.id,
        acqui_utm_id: this.config.acqui_utm.id,
        site_id: this.config.site.id,
      };

      if (
        !params.name ||
        !params.acqui_platform_id ||
        !params.acqui_metric_id ||
        !params.acqui_utm_id ||
        !params.site_id
      ) {
        alert("Merci de remplir tous les champs.");
        return;
      }

      try {
        await this.axiosPost(`/acquisition/config/`, params);
      } catch (error) {
        console.error("Error saving UTM:", error);
        alert(
          "Erreur lors de la création de l'UTM, Vérifier l'inetégrité des données (doublons). Si les données sont intègres utilisez l'outil de report d'erreur"
        );
        this.cancelUtm();
      }
      this.$emit("saved");
    },
    async updateFilteredOptions() {
      if (this.config.acqui_platform.id) {
        this.filteredMetrics = await this.$store.dispatch(
          "acquisition/updateFilteredMetrics",
          this.config.acqui_platform.id
        );
        this.filteredUtms = await this.$store.dispatch(
          "acquisition/updateFilteredUtms",
          this.config.acqui_platform.id
        );
      } else {
        this.filteredMetrics = [];
        this.filteredUtms = [];
      }
    },
  },
  computed: {
    metrics() {
      return this.$store.getters["acquisition/getMetrics"];
    },
    sites() {
      return this.$store.getters["acquisition/getSites"];
    },
    platforms() {
      return this.$store.getters["acquisition/getPlatforms"];
    },
    utms() {
      return this.$store.getters["acquisition/getUtms"];
    },
  },
  watch: {
    "config.acqui_platform.id": "updateFilteredOptions",
  },
};
</script>
<style scoped>
.config-creation {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
